import { ColumnDefinitionEnum } from '@mark43/cad-api';
import { UnitTypeFilterPopover } from '../unit-queues/components/unit-queue-filter-popover';

const FR_FILTER_LIST = [
    ColumnDefinitionEnum.UNIT_BEAT.displayName,
    ColumnDefinitionEnum.UNIT_DISPATCH_AREA.displayName,
    ColumnDefinitionEnum.UNIT_TYPE.displayName,
    ColumnDefinitionEnum.STATION.displayName,
    ColumnDefinitionEnum.ADDITIONAL_CFS.displayName,
    ColumnDefinitionEnum.ALARM_LEVEL.displayName,
    ColumnDefinitionEnum.AVAILABILITY.displayName,
    ColumnDefinitionEnum.CFS_NUMBER_AND_TEXT.displayName,
    ColumnDefinitionEnum.EQUIPMENT.displayName,
    ColumnDefinitionEnum.BEAT.displayName,
    ColumnDefinitionEnum.DISPATCH_AREA.displayName,
    ColumnDefinitionEnum.PATROL_TYPE.displayName,
    ColumnDefinitionEnum.SKILLS.displayName,
    ColumnDefinitionEnum.UNIT_AGENCY.displayName,
];

export function FrUnitsTypeFilterMenu() {
    return <UnitTypeFilterPopover enabledFilters={FR_FILTER_LIST} buttonVariant="outline" />;
}
